import { render, staticRenderFns } from "./first-step-other.vue?vue&type=template&id=7610a8b4&"
import script from "./first-step-other.vue?vue&type=script&lang=js&"
export * from "./first-step-other.vue?vue&type=script&lang=js&"
import style0 from "./first-step-other.vue?vue&type=style&index=0&id=7610a8b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports